import { render } from "./ColorPicker.vue?vue&type=template&id=c61f5468&scoped=true&ts=true&lang=html"
import script from "./ColorPicker.vue?vue&type=script&lang=ts"
export * from "./ColorPicker.vue?vue&type=script&lang=ts"

import "./ColorPicker.vue?vue&type=style&index=0&id=c61f5468&lang=less&scoped=true"

import exportComponent from "/root/.jenkins/workspace/test-saas-doctor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c61f5468"]])

export default __exports__